








































































import {Component, Vue} from 'vue-property-decorator';
import {FooterInfo} from '@/static/footer';

@Component
export default class FooterComponent extends Vue {
  private footerData = FooterInfo;
}
